export function handleError(errorResponse) {
  throw errorResponse;
}

export function handleResponse(response) {
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
  return handleError(response);
}
